import constants from '../constants/constants';
import Logger from '../support/logger';

const log = new Logger();

export default {
  data: {
    v1: vm => ({
      forgotPassword() {
        this.redirect(constants.v1.reset);
      },
      login() {
        return new Promise((resolve) => {
          log.debug({
            category: 'v1',
            message: 'login',
            data: {
              email: vm.loginData.username
            }
          });
          try {
            vm.$http.post(constants.v1.login, vm.loginData)
              .then(({ body }) => {
                resolve(body);
              }, ({ status, body }) => {
                log.warn({
                  category: 'v1',
                  message: `login.${status}`,
                  data: { body }
                });
                resolve(false);
              });
          } catch (error) {
            log.exception(error);
            resolve(false);
          }
        });
      },
      redirect(loc) {
        log.debug({
          category: 'v1',
          message: 'redirect',
          data: {
            location: loc
          }
        });
        vm.processing = false;
        vm.submitBtnTxt = constants.redirectingText;

        if (!loc.match(/^[a-zA-Z]+:\/\//)) {
          loc = `https://${loc}`;
        }

        window.location.href = loc;
      }
    })
  }
};
